//
// JQuery
//
$(() => {
    // PC表示で、スクロール途中で、SingnBoard部分を非表示にする
    // const navPos = $('header').offset().top;
    // var scroll = 0;

    // スクロール途中の処理
    // $(window).on('scroll', function () {
    //     // console.log($(window).height() + ":" + navPos + ":" + $(this).scrollTop())
    //     // console.log('innerWidth: ' + window.innerWidth);
    //     // console.log('innerHeight:' + window.innerHeight);

    //     // 横幅 md:768 以上の場合
    //     if (window.innerWidth >= 768) {
    //         if ($(this).scrollTop() < scroll) {
    //             //上スクロールの時の処理
    //             if ($(this).scrollTop() <= navPos) {
    //                 // $('header').removeClass('fixed');
    //                 $('#signboard').slideDown();
    //             }
    //         } else {
    //             //下スクロールの時の処理
    //             if ($(this).scrollTop() > navPos) {
    //                 // $('header').addClass('fixed')
    //                 $('#signboard').slideUp();
    //             }
    //         }
    //         scroll = $(this).scrollTop();
    //     }
    // });

    let set_position = 0;
    let cnt_down = 0;
    let cnt_up = 0;

    $(window).on('scroll', function () {
        // 横幅 md:768 以上の場合
        if (window.innerWidth >= 768) {
            if (set_position < document.documentElement.scrollTop) {
                // 下にスクロールしている
                cnt_down = cnt_down + 1;
                if (cnt_down >= 10) {
                    $('#signboard').slideUp();
                    cnt_up = 0;
                }
            } else {
                // 上にスクロールしている
                cnt_up = cnt_up + 1;
                if ((cnt_up >= 5) || (0 == $('header').offset().top)) {
                    $('#signboard').slideDown();
                    cnt_down = 0;
                }
            }
            set_position = document.documentElement.scrollTop;
        }
    });


    // menuを開く・閉じる
    $('.btn-trigger').on('click', function () {
        $(this).toggleClass('active');
        $('#menu-sp').toggleClass('active');
        $('#menu-sp').slideToggle(100);

        return false;
    })

    $('#menu-sp ul li').on('click', function() {
        $('#menu-sp').slideToggle(100);
    })

    // #global-sub に　「＋」アイコンを追加する
    // $('#global-sub ul.menu > li').find('ul').each(function () {
    //     $(this).parent().prepend("<div class='btn-shutter'><span></span><span></span></div>");
    // });
    // サブメニューのボタンによる開閉
    // $('.btn-shutter').on('click', function () {
    //     $(this).toggleClass('active');
    //     $(this).parent().find('ul').toggleClass('open');
    //     return false;
    // })
})